// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as ReviewsRouteImport } from './routes/reviews'
import { Route as ServicesIndexRouteImport } from './routes/services/index'
import { Route as ServicesSlugRouteImport } from './routes/services/$slug'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/about.lazy').then((d) => d.Route))
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/contact.lazy').then((d) => d.Route))
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/faq.lazy').then((d) => d.Route))
const ReviewsRoute = ReviewsRouteImport.update({
            id: '/reviews',path: '/reviews',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/reviews.lazy').then((d) => d.Route))
const ServicesIndexRoute = ServicesIndexRouteImport.update({
            id: '/services/',path: '/services/',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/services/index.lazy').then((d) => d.Route))
const ServicesSlugRoute = ServicesSlugRouteImport.update({
            id: '/services/$slug',path: '/services/$slug',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/services/$slug.lazy').then((d) => d.Route))

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,ContactRoute: ContactRoute,FaqRoute: FaqRoute,ReviewsRoute: ReviewsRoute,ServicesSlugRoute: ServicesSlugRoute,ServicesIndexRoute: ServicesIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)